import { createContext, useContext } from "react";
import { usePoll } from "../../data/fetch/useFetch";
import { parseLiveData } from "../../data/parseLiveData";
import { getConfiguration } from "../../data/utils";
import Loader from "../../common/Loader";
import Outlet from "../../router/Outlet";
import { useParams } from "../../router/Router";

const SportDataContext = createContext(null);

export function useSportData() {
    return useContext(SportDataContext);
}

export default function SportDataProvider(props) {
    const conf = getConfiguration();
    const p = useParams();

    const sportId = p.sportId || 0;
    const [isLoading, isError, data] = usePoll(conf.api.getMenuLiveGenerale, { sportId }, (data) =>
        data ? parseLiveData(data) : null
    );

    if (isLoading || isError) {
        return <Loader error={isError} />
    }

    return (
        <SportDataContext.Provider value={data}>
            <Outlet />
        </SportDataContext.Provider>
    );
}
